import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { CLINsTab } from '../tabs/CLINsTab';
export function CLINsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        maxWidth: "full",
        children: /*#__PURE__*/ _jsx(CLINsTab, {
            programId: programId
        })
    });
}
